import { TFunction } from "i18next";
import { PetCare } from "@/types/petCare";

/**
 * Get the frequency text for pet care display (e.g., "Monthly", "Quarterly", "Every 30 days")
 * @param petCare - The pet care object
 * @param t - Translation function
 * @returns Formatted frequency text
 */
export function getPetCareFrequencyText(
  petCare: PetCare,
  t: TFunction
): string {
  const { frequencyType, frequency } = petCare;

  switch (frequencyType) {
    case "monthly":
      return t("petcare.label.frequency_monthly");
    case "quaterly":
      return t("petcare.label.frequency_quarterly");
    case "bi-weekly":
      return t("petcare.label.frequency_bi_weekly");
    case "three-months":
      return t("petcare.label.frequency_three_months");
    case "other":
      if (frequency) {
        return t("reminders.frequencyDaysLabel", {
          count: frequency,
          days: frequency,
        });
      }
      break;
  }
  return "";
}

/**
 * Get the reminder notification date text for pet care display
 * @param petCare - The pet care object
 * @returns Formatted reminder text (e.g., "3 days before", "1 day before", "On the day")
 */
export function getPetCareReminderDateText(petCare: PetCare): string {
  const { reminderDays } = petCare;

  if (reminderDays === null || reminderDays === undefined) {
    return "No reminder set";
  }

  if (reminderDays === 0) {
    return "On the day";
  }

  if (reminderDays === 1) {
    return "1 day before";
  }

  return `${reminderDays} days before`;
}
